import React, { useState } from "react";
import { listNameExists } from "../lib/listNameExists";
import { UserAuth } from "../Context";
import { doc, updateDoc } from "firebase/firestore";
import { db } from "../FirebaseConfig";
import { saveShoppingListToAlgolia } from "../lib/algoliaFunctions";
import LoadingSpinner from "../UserProfile/LoadingSpinner";

const RenameList = ({ closeTray, list }) => {
  const [name, setName] = useState(list?.name);
  const [loading, setLoading] = useState(false);
  const [isDisabled, setIsDisabled] = useState(name === list?.name);
  const [error, setError] = useState("");
  const { user } = UserAuth();

  const handleClose = () => {
    setName(isDisabled ? list?.name : name);
    closeTray();
  };
  const handleRenameList = async () => {
    setLoading(true);
    if ((await listNameExists(user, name)) === true) {
      setError("List name already exists");
      setIsDisabled(true);
      setLoading(false);
      return;
    }
    const listRef = doc(db, "users", user?.uid, "shoppingList", list?.id);
    await updateDoc(listRef, { listName: name });
    handleClose();
    if (list?.visibility === "Public")
      saveShoppingListToAlgolia(user, list?.id);
    setLoading(false);
  };
  return (
    <div
      style={{ paddingTop: "12px", gap: "12px" }}
      className="d-flex flex-column w-100"
      onClick={(e) => e.stopPropagation()}
    >
      <div
        className="d-flex flex-column align-items-center"
        style={{ padding: "0px 32px" }}
      >
        <svg
          width="61"
          height="61"
          viewBox="0 0 61 61"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect
            x="1.25"
            y="1.12646"
            width="58.5"
            height="58.5"
            rx="29.25"
            stroke="#676A79"
            stroke-width="1.5"
          />
          <path
            d="M27.1071 14.5713C26.5746 14.5713 26.1428 15.003 26.1428 15.5356C26.1428 16.0681 26.5746 16.4999 27.1071 16.4999H29.0357V43.4999H27.1071C26.5746 43.4999 26.1428 43.9316 26.1428 44.4641C26.1428 44.9967 26.5746 45.4284 27.1071 45.4284H32.8928C33.4254 45.4284 33.8571 44.9967 33.8571 44.4641C33.8571 43.9316 33.4254 43.4999 32.8928 43.4999H30.9643V16.4999H32.8928C33.4254 16.4999 33.8571 16.0681 33.8571 15.5356C33.8571 15.003 33.4254 14.5713 32.8928 14.5713H27.1071Z"
            fill="#676A79"
          />
          <path
            d="M20.0357 19.7393H27.75V21.6678H20.0357C18.7931 21.6678 17.7857 22.6752 17.7857 23.9178V36.1321C17.7857 37.3748 18.7931 38.3821 20.0357 38.3821H27.75V40.3107H20.0357C17.728 40.3107 15.8572 38.4399 15.8572 36.1321V23.9178C15.8572 21.6101 17.728 19.7393 20.0357 19.7393Z"
            fill="#676A79"
          />
          <path
            d="M39.9643 38.3821H32.25V40.3107H39.9643C42.272 40.3107 44.1429 38.4399 44.1429 36.1321V23.9178C44.1429 21.6101 42.272 19.7393 39.9643 19.7393H32.25V21.6678H39.9643C41.2069 21.6678 42.2143 22.6752 42.2143 23.9178V36.1321C42.2143 37.3748 41.2069 38.3821 39.9643 38.3821Z"
            fill="#676A79"
          />
        </svg>

        <div
          style={{
            fontFamily: "Inter",
            fontWeight: "400",
            fontSize: "14px",
            textAlign: "center",
          }}
        >
          Update the name of your shopping list to better reflect its purpose.
        </div>
      </div>
      <form
        onSubmit={(e) => {
          e.preventDefault();
          if (!isDisabled) handleRenameList();
        }}
      >
        <div>
          <input
            type="text"
            value={name}
            onChange={(e) => {
              setIsDisabled(false);
              setName(e.target.value);
              setError("");
              if (list?.name === e.target.value) {
                setIsDisabled(true);
              } else if (e.target.value.length === 0) {
                setIsDisabled(true);
              } else if (/^\d+$/.test(e.target.value)) {
                setError("List name cannot be completely numeric");
              } else if (
                /[!@#$%^&*,.?":{}|<>\=+\;()/\\[\]]/.test(e.target.value)
              ) {
                setError("List name cannot contain special characters");
              }
            }}
            style={{ height: "42px", borderRadius: "8px" }}
            className="w-100 border-0 px-3"
            placeholder="Enter list name"
          />
          {error && <div className="text-danger mt-2">{error}</div>}
        </div>
        <div
          className="d-flex flex-column w-100"
          style={{ gap: "8px", padding: "6px 0px" }}
        >
          <button
            type="submit"
            style={{
              height: "42px",
              borderRadius: "8px",
              backgroundColor: isDisabled ? "#cecece" : "#005FDA",
              color: isDisabled ? "#3e3e3e" : "white",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
            className="border-0"
          >
            {loading ? <LoadingSpinner /> : "Update"}
          </button>
          <div
            onClick={closeTray}
            style={{
              height: "42px",
              borderRadius: "8px",
              backgroundColor: "#FFFFFF",
              color: "#676A79",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            Cancel
          </div>
        </div>
      </form>
    </div>
  );
};

export default RenameList;
